import React from 'react';
import { CheckIcon, AwardIcon, UserIcon, ClockIcon, CheckCircleIcon } from 'lucide-react';
export function ResultsSection() {
  return <section className="py-10 mb-12 bg-amber-50 rounded-lg" data-id="element-475">
      <div className="max-w-3xl mx-auto px-4" data-id="element-476">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-amber-900 mb-6" data-id="element-477">
          Resultados Comprobados
        </h2>
        <p className="text-lg text-amber-800 text-center font-medium mb-8" data-id="element-478">
          Miles de Estudiantes Ya Han Transformado Sus Cocinas
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-479">
          <div className="bg-white p-4 rounded-lg shadow-sm flex flex-col items-center" data-id="element-480">
            <AwardIcon size={28} className="text-amber-600 mb-2" data-id="element-481" />
            <h3 className="font-bold text-amber-900 mb-1" data-id="element-482">
              Técnicas Profesionales
            </h3>
            <p className="text-sm text-gray-700 text-center" data-id="element-483">
              Técnicas basadas en métodos clásicos de repostería uruguaya.
            </p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm flex flex-col items-center" data-id="element-484">
            <CheckCircleIcon size={28} className="text-amber-600 mb-2" data-id="element-485" />
            <h3 className="font-bold text-amber-900 mb-1" data-id="element-486">
              Experiencia Comprobada
            </h3>
            <p className="text-sm text-gray-700 text-center" data-id="element-487">
              Recetas probadas en talleres y clases dictadas por Stella.
            </p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm flex flex-col items-center" data-id="element-488">
            <UserIcon size={28} className="text-amber-600 mb-2" data-id="element-489" />
            <h3 className="font-bold text-amber-900 mb-1" data-id="element-490">
              Comunidad de Apoyo
            </h3>
            <p className="text-sm text-gray-700 text-center" data-id="element-491">
              Únete a cientos de alumnos que ya dominan la milhojas perfecta.
            </p>
          </div>
        </div>
        {/* Redesigned stats section - more compact for mobile */}
        <div className="flex overflow-x-auto gap-3 pb-4 snap-x snap-mandatory md:grid md:grid-cols-3 md:gap-4 md:pb-0 mb-6 no-scrollbar" data-id="element-492">
          <div className="flex-shrink-0 snap-center w-[160px] md:w-auto bg-white rounded-lg shadow-sm p-4 flex flex-col items-center justify-center text-center" data-id="element-493">
            <p className="text-3xl font-bold text-amber-600 mb-1" data-id="element-494">1,200+</p>
            <p className="text-xs md:text-sm text-gray-700" data-id="element-495">
              Alumnos satisfechos
            </p>
          </div>
          <div className="flex-shrink-0 snap-center w-[160px] md:w-auto bg-white rounded-lg shadow-sm p-4 flex flex-col items-center justify-center text-center" data-id="element-496">
            <p className="text-3xl font-bold text-amber-600 mb-1" data-id="element-497">30+</p>
            <p className="text-xs md:text-sm text-gray-700" data-id="element-498">
              Años de experiencia
            </p>
          </div>
          <div className="flex-shrink-0 snap-center w-[160px] md:w-auto bg-white rounded-lg shadow-sm p-4 flex flex-col items-center justify-center text-center" data-id="element-499">
            <p className="text-3xl font-bold text-amber-600 mb-1" data-id="element-500">100%</p>
            <p className="text-xs md:text-sm text-gray-700" data-id="element-501">
              Método comprobado
            </p>
          </div>
        </div>
        <p className="text-center text-gray-700 text-sm md:text-base" data-id="element-502">
          Ya más de 1.200 alumnos han probado este método y hoy preparan
          milhojas que sorprenden a sus familias y clientes. Algunos incluso
          comenzaron su propio emprendimiento de repostería gracias a esta
          receta.
        </p>
      </div>
    </section>;
}